export default __webpack_public_path__ + "static/media/User_Manual.68e79ecc.svg";